const getTransriptsFromClass = function (html, atype, id) {
  const pattern = /<span class=\"(.*?)\"/g;
  let match;
  const transcripts = [];
  while ((match = pattern.exec(html))) {
    const spanclass = match[1];
    if (spanclass.indexOf(atype + '-' + id) >= 0) {
      for (const singleclass of spanclass.split(' ')) {
        if (singleclass.indexOf('id-') >= 0) {
          const singleid = singleclass.substring(3);
          transcripts.push(singleid);
        }
      }
    }
  }
  return transcripts;
};

const state = {};

const getters = {
  getSeiteDataExtendInfo: (state, rootGetters, rootState) => (seite, type, viewKey) => {
    if (!seite || !seite.$_docInfo) {
      return;
    }

    const docs = seite.$_docInfo;
    switch (type) {
      case 'acco_inventarisierung':
        const out = [];
        let options = [

          {
            label: 'Dokumenttitel',
            field: '98_documenttitle'
          },
          {
            label: 'Art der Seite',
            field: '98_artderseite'
          }, {
            label: 'Format',
            field: '98_format'
          },
          {
            label: 'Anzahl der Exemplare',
            field: '98_anzexemplare'
          }

        ];


        if (viewKey !== 'werbe') {
          options = options.concat([
            {
              label: 'Datum von',
              field: '98_datum'
            },
            {
              label: 'Datum bis',
              field: '98_datumbis'
            },
          ]);
        }


        options = options.concat([
          {
            label: 'Datum',
            field: '98_datumalternativ'
          },
          {
            label: 'Datum (Kommentar)',
            field: '98_datumkommentar'
          },
          {
            label: 'Status',
            field: '98_seistatus'
          },
          {
            label: 'Sachbegriff',
            field: '98_sachbegriff'
          },
          {
            label: 'Material/Technik',
            field: '98_materialtechnik'
          },
          {
            label: 'Inventar-Nr',
            field: '98_inventarnr'
          }, {
            label: 'Standort/Eigentümer',
            field: '98_standorteigen'
          }
          ,
          {
            label: 'Signatur Sprengel Museum Hannover',
            field: '98_KSAsignaturItem'
          },
          {
            label: 'Signatur',
            field: '98_SonstigeArchiveItem'
          },
        ]);





        docs.forEach((doc, i) => {
          const sour = doc._source;
          const tmp = [];
          options.forEach(opt => {
            const val = sour[opt.field];
            if (val !== undefined) {
              tmp.push({
                label: opt.label,
                value: val
              });
            }
          });
          out.push({
            docID: doc._id,
            data: tmp
          });
        });
        return out;

      case 'personen':
        const list = rootState.personen.collection2;
        if (!seite || !seite.$_accoId_transcript_mapping) {
          return;
        }
        if (!list) {
          return;
        }
        const trans = seite.$_accoId_transcript_mapping["index_personenindex_8"];
        const seiteIds = seite.seiteIds;
        const pers = list.filter(it => {
          return it.docIds.find(id => seiteIds.indexOf(id) > -1);
        });
        pers.forEach(p => {
          const obj = trans.find(m => m.ID - p.lemmaID === 0);
          if (obj.ids.length > 0) {
            p.transcripts = obj.ids;
          }
        });

        return pers;

      case 'orte':
        if (!seite || !seite.$_accoId_transcript_mapping) {
          return;
        }
        const orte = [];
        const orteMapping = seite.$_accoId_transcript_mapping['index_ortsindex_7'];
        docs.forEach(doc => {
          const arr = doc._source['index_ortsindex_7'];
          if (arr) {
            arr.forEach(a => {
              const mapItem = orteMapping.find(m => m.ID === a.ID);
              if (mapItem) {
                a = JSON.parse(JSON.stringify(a));
                a.transcripts = mapItem.ids;
                orte.push(a)
              }
            })
          }
        });

        return orte;

      //
      // themen
      case 'themen':
        const themenMap = new Map();
        const colors = rootState.themen_colors;
        const allTranscripts = seite.$_allTranscripts;
        docs.forEach(doc => {
          const arr = doc._source['index_ursonate_25'];
          let docTranscripts;
          if (allTranscripts) {
            docTranscripts = allTranscripts.find(d => d.docID === doc._id);
          }
          if (arr) {
            arr.filter(a => a.parentID === "" || a.parentID === "0").forEach(a => {
              const id = a.ID;
              if (themenMap.has(id)) {
                return;
              }
              //之前搜集的 index_ursonate_25 对应的 transcriptIds
              const obj = seite.$_accoId_transcript_mapping['index_ursonate_25'].find(m => m.ID === id);
              const ids = obj.ids;
              const color = colors[a.content];
              if (docTranscripts) {
                //transcript obj 添加  颜色 $_color 
                docTranscripts.transcripts.forEach(tr => {
                  if (ids.indexOf(tr.id) > -1) {
                    tr.$_color = color;
                  }
                });
              }
              const thema = a.content;
              themenMap.set(id, {
                checked: false,
                info: a,
                class: thema.indexOf('Thema') > -1 ? thema.replace(/\s/g, '-').toLowerCase() : '',
                transcripts: ids
              });
            });
          }
        });
        const themenOut = [...themenMap.values()];
        themenOut.sort((a, b) => {
          a = a.info.content;
          b = b.info.content;
          if (a > b) {
            return 1;
          } else if (a < b) {
            return -1;
          }
          return 0;
        });
        return themenOut;
    }
  },

  getModusByIdKey: (state, getters, rootState) => ({ modusId, viewKey }) => {
    return rootState[viewKey].modusData.modusItems.find(it => it.id === modusId);
  },

  getModusUrlparams: (state, getters, rootState) => modus => {
    let ansicht = rootState[modus.option.viewKey].modusData.modusItems.find(m => m.id === 'ansichtsmodus');
    let ansicht_urlparmas = ansicht.option.urlparams;
    if (!ansicht_urlparmas.merzId) {
      const merzListe = rootState[modus.option.viewKey].merzListe;
      if (merzListe) {
        ansicht_urlparmas.merzId = merzListe[0].id;
      }
    }

    const urlparams = modus.option.urlparams;
    Object.keys(urlparams).forEach(k => {
      if (urlparams[k] == null) {
        urlparams[k] = ansicht_urlparmas[k];
      }
    });

    if (modus.id === 'vergleichsmodus') {
      const outUrlparams = {};
      const urlparams_b = modus.option.b.urlparams;
      Object.keys(urlparams_b).forEach(k => {
        //init
        if (urlparams_b[k] == null) {
          urlparams_b[k] = ansicht_urlparmas[k];
        }
        outUrlparams['b_' + k] = urlparams_b[k];
        outUrlparams[k] = urlparams[k];
      });
      return outUrlparams;
    }
    return urlparams;
  },

  getModusMerz: (state, getters, rootState) => modus => {
    const data = rootState[modus.option.viewKey];
    return data.merzListe && data.merzListe.find(m => m.id === modus.option.urlparams.merzId);
  },

  getModusSeiteIdx: () => modus => {
    return parseInt(modus.option.urlparams.seiteIdx, 10);
  },

  getModusSeiten: (state, getters, rootState) => modus => {
    const data = rootState[modus.option.viewKey];
    if (!data.merzListe) {
      return;
    }
    const merz = data.merzListe.find(m => m.id === modus.option.urlparams.merzId);
    if (merz) {
      return merz.seiten;
    }
  },

  //vergeleich seite
  b_merz: (state, getters, rootState) => modus => {
    const data = rootState[modus.option.viewKey];
    const merzId = modus.option.b.urlparams.merzId;
    return data.merzListe && data.merzListe.find(m => m.id === merzId);
  },

  b_seiteIdx: (state, getters, rootState) => modus => {
    return parseInt(modus.option.b.urlparams.seiteIdx, 10);
  },
  vergleichsseite: (state, getters, rootState) => modus => {
    const seiteIdx = getters.b_seiteIdx(modus);
    const seiten = getters.b_seiten(modus);
    if (seiten) {
      return seiten[seiteIdx];
    }
  },
  b_seiten: (state, getters) => modus => {
    let merz = getters.b_merz(modus);
    if (merz) {
      return merz.seiten;
    }
  }
};

const actions = {
  ['changeModusMerz']({ }, { modus, merzId }) {
    modus.option.urlparams.merzId = merzId;
    modus.option.urlparams.seiteIdx = 0;
  },

  ['changeModusSeite']({ }, { modus, seiteIdx }) {
    modus.option.urlparams.seiteIdx = seiteIdx;
  },

  ['changeTransparenz']({ }, { modus, val }) {
    modus.option.transparenz = val;
  },
  ['b_changeMerz']({ }, { modus, merzId }) {
    modus.option.b.urlparams.merzId = merzId;
    modus.option.b.urlparams.seiteIdx = 0;
  },
  ['b_changeSeite']({ }, { modus, seiteIdx }) {
    modus.option.b.urlparams.seiteIdx = seiteIdx;
  },

  ['changeModus']({ rootState }, { modus }) {
    const viewKey = modus.option.viewKey;
    const data = rootState[viewKey];
    data.modusData.active_modus = modus;
  },

  ['updateModusOption']({ rootState }, { modusOption, key, val }) {
    const opts = key.split('/');
    if (opts.length != 2) {
      console.error('opts length error');
      return;
    }
    const modusKey = opts[0];
    const modus = rootState[modusOption.viewKey].modusData.modusItems.find(m => {
      return m.option.key === modusKey || (m.option.b && m.option.b.key === modusKey);
    });

    if (modusKey === 'b_vergleich') {
      modus.option.b[opts[1]] = val;
    } else {
      modus.option[opts[1]] = val;
    }
  }
};

const mutations = {
  ['updatePopupBoxList'](state, obj) {
    const { data, modusOption } = obj;
    const item = modusOption.popupBoxList.find(p => {
      return p.merzId === data.merzId && p.seiteIdx === data.seitIdx;
    });
    if (item) {
      item.data = data;
    } else {
      data.seiteIdx = modusOption.urlparams.seiteIdx;
      data.merzId = modusOption.urlparams.merzId;
      modusOption.popupBoxList.push(data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/modus.js